export const updateGateCheckInMini = /* GraphQL */ `
  mutation UpdateGateCheckIn(
    $input: UpdateGateCheckInInput!
    $condition: ModelGateCheckInConditionInput
  ) {
    updateGateCheckIn(input: $input, condition: $condition) {
      id
      status
      dockAssignment
      driverName
      truckPlate
      arrivedAt
      calledAt
      completedAt
      updatedBy
    }
  }
`;

// A gate check-in the yard office wrote, for a truck that never reached the
// kiosk. driverApi writes its own rows straight to DynamoDB in a transaction;
// this goes through AppSync, which composes the gateCheckInByYardByStatus
// synthetic sort key ("status#arrivedAt") for us — the one thing the lambda
// has to build by hand.
export const createGateCheckInMini = /* GraphQL */ `
  mutation CreateGateCheckIn(
    $input: CreateGateCheckInInput!
    $condition: ModelGateCheckInConditionInput
  ) {
    createGateCheckIn(input: $input, condition: $condition) {
      id
      reloadYardId
      driverSessionId
      carrierUserId
      driverName
      carrierName
      shipmentKey
      inboundId
      outboundId
      timeslotId
      scheduledDateTime
      referenceEntered
      truckPlate
      trailerNumber
      status
      dockAssignment
      arrivedAt
      updatedBy
    }
  }
`;
